import { gql } from "@apollo/client";

export const GET_USER_SUB_AREA_ATUACAO = gql`
query GetUserSubAreaAtuacao{
  GetUserSubAreaAtuacao{
    id
    area_atuacao{
      id  
      name
    }
    user {
      id
      name
    }
  }
}
`
